
export const UPDATED_CATALOG = 'UPDATED_CATALOG'

export function updateCatalog (lang, module) {
  return dispatch => {
    dispatch({
      type: UPDATED_CATALOG,
      data: module,
      lang
    })
  }
}
